module.exports = __webpack_public_path__ + "img/careIcon.61e59a69.svg";